import api from '../configurations/axios';
import FreeTicketWinnerResult from '../responses/FreeTicketWinnerResult';

export interface FreeTicketWinnerEntry {
    numberOfEntries: number;
    numberOfUsers: number;
}

class FreeTicketWinnersService {
    async addFreeTicketWinners(
        competitionId: number,
        entries: FreeTicketWinnerEntry[]
    ): Promise<FreeTicketWinnerResult[]> {
        const response = await api.post<FreeTicketWinnerResult[]>(
            `/api/winners/free-ticket-winners/${competitionId}`,
            { entries }
        );
        return response.data;
    }
}

export default new FreeTicketWinnersService();
